export const Divider = () => {
    return <div className="border-b border-gray-300" />
}